<template>
  <footer class="site-footer">
    <div class="site-footer__wrapper">
      <div class="site-footer__wrapper__logo-block">
        <div class="site-footer__wrapper__logo-block__logo">
          <SiteLogo class="site-footer__wrapper__logo-block__logo__img" />
          <SiteLogoTitle />
        </div>
        <div class="site-footer__wrapper__logo-block__text">
          CRA Freelance est un outil développé par Litee Solutions, société éditrice de logiciels en ligne.
        </div>
      </div>
      <div class="site-footer__wrapper__section">
        <div class="site-footer__wrapper__section__title">
          Réseaux sociaux
        </div>
        <ul class="site-footer__wrapper__section__links">
          <li><a href="https://www.linkedin.com/showcase/freelance-it-tools/" target="_blank">LinkedIn</a></li>
          <li><a href="https://twitter.com/search?q=%23freelance%20it%20tools&src=typed_query" target="_blank">Twitter</a></li>
        </ul>
      </div>
      <div class="site-footer__wrapper__section">
        <div class="site-footer__wrapper__section__title">
          Ressources
        </div>
        <ul class="site-footer__wrapper__section__links">
          <li>
            <span
            @click="$router.push({
              hash: '#features',
              path: '/'
            })"
            >Fonctionnalités</span>
          </li>
          <li>
            <span
            @click="$router.push({
              hash: '#price',
              path: '/'
            })"
            >Prix</span>
          </li>
          <li>
            <NuxtLink to="/blog">Blog</NuxtLink>
          </li>
        </ul>
      </div>
      <div class="site-footer__wrapper__section">
        <div class="site-footer__wrapper__section__title">
          Contact et légal
        </div>
        <ul class="site-footer__wrapper__section__links">
          <li>Contact</li>
          <li>
            <span
            @click="$router.push({
              hash: '#feedback',
              path: '/'
            })"
            >Avis</span>
          </li>
          <li>
            <NuxtLink to="/legal">Mentions légales</NuxtLink>
          </li>
          <li>
            <NuxtLink to="/rgpd">Politique de confidentialité</NuxtLink>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>


<script setup>
  import SiteLogo from '@/components/SiteLogo'
  import SiteLogoTitle from '@/components/SiteLogoTitle'

  const emit = defineEmits(['hash'])
</script>
<style lang="scss">
  $desktop-breakpoint: 990px;
  $tablet-breakpoint: 672px;

  .site-footer {
    background-color: #131427;
    padding: 40px 15px 15px;
   
    @media screen and (min-width: $tablet-breakpoint) {
      padding-left: 30px;
      padding-right: 30px;
    }
    @media screen and (min-width: $desktop-breakpoint) {
      display: flex;
      justify-content: center;
    }

    &__wrapper {
      max-width: 1300px;
      display: grid;
      grid-template-columns: 1fr;

      @media screen and (min-width: $tablet-breakpoint) {
        grid-template-columns: 1.5fr 1fr;
      }

      @media screen and (min-width: 1200px) {
        grid-template-columns: 2fr 1fr 1fr 1fr;
      }

      &__logo-block {
        flex-grow: 10;
        flex-shrink: 10;
        color: white;
        margin-bottom: 25px;
        font-weight: 200;
        
        @media screen and (min-width: $desktop-breakpoint) {
          padding: 40px;
        }

        &__logo {
          display: flex;
          align-items: center;
          margin-bottom: 25px;
          
          &__img {
            height: 70px;
            width: 52.1px;
            margin-right: 10px;
            @media screen and (min-width: $desktop-breakpoint) {
              margin-right: 15px;
            }
          }

          @media screen and (min-width: $desktop-breakpoint) {
            margin-bottom: 30px;
          }
        }

        &__text {
          padding-right: 15px;
          @media screen and (min-width: $tablet-breakpoint) {
            padding-right: 50px;
          }
        }
      }

      &__section {
        color: white;
        margin-bottom: 25px;
        flex-grow: 10;

        @media screen and (min-width: $desktop-breakpoint) {
          padding: 40px;
        }
        &__title {
          font-weight: 500;
          font-size: 22px;
          margin-bottom: 15px;
        }
        &__links {
          list-style: none;
          margin: 0;
          padding: 0;

          li {
            padding: 5px 0;
            font-weight: 200;
            a, span {
              cursor: pointer;
              color: white;
              text-decoration: none;
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
  }
</style>